<template>
    
    <div class="row m-1 mt-2">
       
            <div class="col-12">
                <div class="card">

                    <div class="card-body">
                        <div class="row">

                            <div class="col-9 mb-2">
                                <h1>Elenco pratiche</h1>

                                <div class="d-none">
                                    <font-awesome-icon icon="eye" ref="viewIcon"></font-awesome-icon>
                                    <font-awesome-icon icon="envelope" ref="envelope"></font-awesome-icon>
                                    <font-awesome-icon icon="phone" ref="phone"></font-awesome-icon>
                                    <font-awesome-icon icon="circle" ref="circle"></font-awesome-icon>
                                </div>
                                 </div>
<div class="col-3  text-right mb-2">
   
    <button class="btn  btn-secondary ml-5" v-if="isAdministrator || isSuperOperator" @click="excel">
 <font-awesome-icon icon="file-excel" class="mr-2"></font-awesome-icon> Scarica report
                                </button>
</div>
                           
                             <div class="col-12 mb-2">
                             
                                <router-link class="btn btn-sm btn-primary" :to="{name:'route-create-inheritance'}">
                                    <font-awesome-icon icon="plus-circle"></font-awesome-icon> Aggiungi nuova segnalazione
                                </router-link>
                                <router-link class="btn btn-sm btn-success ml-5" :to="{name:'route-dashboard'}">
                                    <font-awesome-icon icon="chart-pie"></font-awesome-icon> Visualizza Statistiche
                                </router-link>


                                
                            </div>
                            <div class="col-4"><input type="text" placeholder="Ricerca per codice, documento, intestatario, decuius" class="form-control" v-model="query" /></div>
                            <div class="col-3">
                                <select class="form-control" v-model="status">
                                    <option value="None">Tutti gli stati</option>
                                    <option value="Open">Da prendere in carico</option>
                                    <option value="InCharge">Da riscontrare</option>
                                    <option value="Found">Riscontrata</option>
                                    <option value="Verified">Pro-forma acconto da inviare</option>
                                    <option value="DownPaymentPaid">Acconto pagato</option>
                                    <option value="DocumentationWaiting">In attesa della documentazione</option>
                                    <option value="DocumentationOk">Documentazione completa</option>
                                    <option value="PaymentWaiting">In attesa del pagamento a saldo</option>
                                    <option value="Payed">Pagamento ricevuto</option>
                                    <option value="Sent">Evasa</option>
                                    <option value="Processed">Inviata</option>
                                    <option value="KO">Annullata</option>
                                </select>
                            </div>
<div class="col-3">
<select class="form-control" v-model="operator">
     <option value="">Tutti gli operatori</option>
    <option v-for="(item, index) in operators" :value="index">{{item}}</option>
</select>

</div>
                            <div class="col-2"><button class="btn  btn-primary" @click.prenvent="loaddata"> <font-awesome-icon icon="filter" ref="filter"></font-awesome-icon> Filtra</button></div>
                            <div class="col-12">
                                <hr />

                                <table ref="table" id="list-table" class="table table-hover table-striped w-100"></table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
 <a ref="attachmentA"></a>
            <!-- /.col -->
        </div>


</template>
<style>
    .social-box {
        min-height: 132px;
        margin-bottom: 1.5rem;
        text-align: center;
        background: #fff;
        border: 1px solid #d1d4d7;
    }

        .social-box i {
            display: block;
            margin: -1px -1px 0;
            font-size: 29px;
            line-height: 59px;
            background: #e4e5e6;
        }

        .social-box.ko i {
            background: #f86c6b;
            color: #fff
        }

        .social-box.active i {
            background: #63C2DE;
            color: #fff
        }

        .social-box.success i {
            background: #4dbd74;
            color: #fff
        }
</style>
<script>

    import axios from 'axios';
import moment from 'moment';
    export default {
        computed: {
           operators: function () {
                return this.$store.state.operators;
            },
            isAdministrative: function () {
                
                var u = false;

                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrative" || this.$store.state.user.roles[i] =="administrator") {
                        u = true;
                        break;
                    }
                }

                return u;
            }, isAdministrator() {
                if (!this.$store.state.user) return false;
                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "administrator") return true;
                }
                return false;
            }, isSuperOperator() {
                if (!this.$store.state.user) return false;
                for (var i = 0; i < this.$store.state.user.roles.length; i++) {
                    if (this.$store.state.user.roles[i] == "superoperator") return true;
                }
                return false;
            }
        },
        components: {
           
        },
        data() {
            return {
                operator:"",
                status: "None",
                query: "",
                total: 0,
                open: 0,
                closed: 0,
                ko: 0,
                active: 0
            }

        },
        name: 'InheritancesList',
        beforeMount() {
            var me = this;

             me.$store.dispatch("verifyToken");

    axios
                .get('inheritances/operators/all').then(function (result) {
                    me.$store.state.operators = result.data.data;

                });
            window.ViewInformation = function (id) {
                me.$router.push({
                    name: "route-info-inheritance",
                    params: {id:id},
                        replace: true
                    });
              
                return false;
            };
            
            document.body.classList.add('sidebar-minimized');
            document.body.classList.add('brand-minimized');
           
            for (var i = 0; i < this.$store.state.user.roles.length; i++) {

                if (this.$store.state.user.roles[i] == "administrator") {
                    $('.administrator').removeClass("hidden");
                    break;
                }
                if (this.$store.state.user.roles[i] == "user") {
                    this.$router.push({
                        name: "route-create-inheritance",
                        replace: true
                    });
                    return;
                }
            }
           
        },

        mounted() {
            setTimeout(
            this.loaddata,200);
        },
        methods: {
excel(){
    var me = this;
   
    var o =this.$filters.reportname("RendicontazionePratiche");
 axios.get("inheritances/report", { responseType: 'blob' }).then(function (result) {
                    var blob = new Blob([result.data], { type: result.headers["content-type"] });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                        window.navigator.msSaveOrOpenBlob(blob, o);
                    } else {
                        me.$refs.attachmentA.href = URL.createObjectURL(blob)
                        me.$refs.attachmentA.download = o;
                        me.$refs.attachmentA.click()
                    }
                });

},


            getData() {
                var me = this;
                axios.get("inheritances/chart").then((result) => {
                    me.chartData = result.data;
                    me.total = 0;
                    me.active = 0;
                    for (var i = 0; i < me.chartData.length; i++) {
                        me.total += me.chartData[i].count;
                        if (me.chartData[i].state == "KO") {
                            me.ko = me.chartData[i].count;
                        }
                        else if (me.chartData[i].state == "Open") {
                            me.open = me.chartData[i].count;
                        }
                        else if (me.chartData[i].state == "Sent") {
                            me.closed = me.chartData[i].count;
                        }
                        else {
                            me.active += me.chartData[i].count;
                        }
                    }
                });
            },
            loaddata: function () {
                this.getData()
                   var me = this;
               me.$store.dispatch('inheritanceCheck');


                var circle = "&#9679;";
                if (me.$refs && me.$refs.circle && me.$refs.circle.outerHTML) {
                    circle = me.$refs.circle.outerHTML 
                }
                var phone = "";
                if (me.$refs && me.$refs.phone && me.$refs.phone.outerHTML) {
                    phone = me.$refs.phone.outerHTML 
                }
                var envelope = "";

                if (me.$refs && me.$refs.envelope && me.$refs.envelope.outerHTML) {
                    envelope = me.$refs.envelope.outerHTML 
                }

                 var eye = "";

                if (me.$refs && me.$refs.eye && me.$refs.eye.outerHTML) {
                    phone = me.$refs.eye.outerHTML 
                }
                if ($.fn.DataTable.isDataTable('#list-table')) {
                    $('#list-table').DataTable().destroy();

                }
                $.fn.dataTable.ext.errMode = "none";
            var $table = $('#list-table').DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "ordering": false,
                "ajax": {
                    "url": window.SETTINGS.apiUrl + "/inheritances/list",
                    'type': 'POST',
                   
                    "data": function (d) {
                        d.query = me.query;
                        d.status = me.status;
                        d.filters = [
                            {
                            key:"operator",
                            value:me.operator

                            }
                        ]
                        return JSON.stringify(d);
                    },
                    'beforeSend': function (request) {
                        request.setRequestHeader("Authorization", "Bearer " + me.$store.state.user.token);
                        request.setRequestHeader("Content-Type", "application/json");
                    }
                },
                "createdRow": function (row, data, dataIndex) {
                    if ($(row).find('.notpayed').length>0) {
                        $(row).find('td').addClass("border border-danger alert alert-danger");
                    }
},
                "columns": [
                    {
                        "data": "internalCode", "name": "internalCode", "title": "Codice",
                        "render": function (data, type, row, meta) {
                            var notpayedclass = "";
                            if (me.isAdministrative && !row.allPayed && (row.state!="DownPaymentWaiting" && row.state!="PaymentWaiting" )) {
                                notpayedclass ="notpayed"
                            }
                            var badgeVisible = (row.totalDownPaymentTaxes && row.totalDownPaymentTaxes != 0 && row.totalDownPaymentTaxes && row.totalDownPaymentTaxes != row.totalBalanceTaxes);
                            var output =
                                `<div class="row ${notpayedclass}">
<div class="col">

<span class="text-muted">${me.$filters.formatDate(row.date)}</span>
<h5><a href='#/inheritance/${row.inheritanceId}' onclick="ViewInformation('${row.inheritanceId}')">${row.deceaseName} ${row.deceaseSurname}</a></h5>
<span class="badge badge-danger ${badgeVisible ? "" : "d-none"}">FILE DCM CON IMPOSTE DIVERSE</span>
<span class="d-block ${me.$filters.stateTextCss(row.state)}">${circle} ${me.$filters.state(row.state)}</span>

<small class="mt-4 d-block font-italic">Ultima modifica ${me.$filters.formatDate(row.lastUpdate)} ${((row.chargeUser)?"In carico a <strong>"+row.chargeUser.firstName+" "+ row.chargeUser.lastName + "</strong>":"")}</small>
</div>
<div class="col">
<strong>Provenienza:</strong>${row.authority.name} ${row.agency.name}<br/>
<strong>Erede: </strong>${row.name} ${row.surname} ${(row.phone != '' ? "<br/>" + (phone) + " " + row.phone : "")}  ${(row.email != '' ? "<br/>" + (envelope) + " <a href=\"mailto:" + row.email + "\">" + row.email + "</a>" : "")}
<br/><strong>Numero pratica: ${row.internalCode}</strong>
</div>
</div>`
                          
                            return output;
                        }
                    }

                ]


            });

                $table.on('select', function (e, dt, type, indexes) {

                })
            }
        }
    };
</script>
